import { render } from "./UpdateMaterialPage.vue?vue&type=template&id=250a8776"
import script from "./UpdateMaterialPage.vue?vue&type=script&lang=js"
export * from "./UpdateMaterialPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__